import { IDeepCopy } from "@common/interfaces/i-deep-copy";

export class TimeZone implements IDeepCopy<TimeZone> {
  public id: string = null;
  public title: string = null;

  constructor(id: string, displayName: string) {
    this.id = id;
    this.title = displayName;
  }

  public deepCopy(): TimeZone {
      let ret = new TimeZone(this.id, this.title);
      return ret;
  }
}
